define('specific/pushdetails/models/PushDetailsModel', [

], function() {

    var PushDetailsModel = Backbone.Model.extend({
        defaults: {
            type: "pushdetails",
            viewId: "",
            datas: null,
            isReady: false
        }
    });

    return PushDetailsModel;
});
